import { Extension } from '@tiptap/core';

export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6] as const;
export type HeadingLevel = (typeof HEADING_LEVELS)[number];

export const TEXT_SIZES = ['large', 'small', 'extra-small'] as const;

export type TextSize = (typeof TEXT_SIZES)[number];

export const TextSizeExtension = Extension.create({
  name: 'textSize',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph'],
        attributes: {
          textSize: {
            default: null,
            parseHTML: element =>
              element.getAttribute('data-text-size') || null,
            renderHTML: attributes => {
              if (!attributes.textSize) return {};
              return {
                'data-text-size': attributes.textSize,
                class: `text-${attributes.textSize}`,
              };
            },
          },
        },
      },
    ];
  },
});
